import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { convertDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type { Scalar } from 'modules/attendance/store/models/AttendanceSettingsEvent'
import {
  BOOLEAN_FIELDS,
  DATE_FIELDS,
  POLICY_FIELDS,
  SECOND_FIELDS,
  SPECIAL_FIELDS,
} from 'modules/attendance/store/models/AttendanceSettingsEvent'

import { getFeatureName, getFieldName } from './getTranslations'

interface Props {
  feature: string
  field: string
  values?: Scalar[]
}

const Message = ({ feature, field, values }: Props) => {
  const formatValue = (value: Scalar | undefined) => {
    if (SECOND_FIELDS.includes(field)) return Number(value) / 60.0

    if (DATE_FIELDS.includes(field)) {
      return value ? convertDate(value.toString(), 'backend_datetime', 'ui') : '-'
    }

    return value ?? '-'
  }

  const message = (): string | null => {
    if (SPECIAL_FIELDS.includes(field))
      return i18n.t('time_tracking.settings.versions.sidepanel.messages.fields.accuracy')

    const featureName = getFeatureName(feature)
    const fieldName = getFieldName(field)

    if (!featureName || !fieldName || !values || values?.length < 2) return null

    const fromValue = formatValue(values[0])
    const toValue = formatValue(values[1])
    const args = { feature: featureName, field: fieldName, fromValue, toValue }

    if (BOOLEAN_FIELDS.includes(field)) {
      return toValue
        ? i18n.t('time_tracking.settings.versions.sidepanel.messages.enabled', args)
        : i18n.t('time_tracking.settings.versions.sidepanel.messages.disabled', args)
    }

    if (POLICY_FIELDS.includes(field)) {
      return i18n.t('time_tracking.settings.versions.sidepanel.messages.default_policy_field', args)
    }

    return i18n.t('time_tracking.settings.versions.sidepanel.messages.default', args)
  }

  if (!message() || !values) return null

  return (
    <Text size="200" color="grey800" weight="medium">
      {message()}
    </Text>
  )
}

export default observer(Message)
